module.exports = __webpack_public_path__ + "static/img/logo.c00f2772.svg";